import {
  IonChip,
  IonIcon,
  IonLabel,
  IonRouterContext,
  IonRouterLink,
} from '@ionic/react';
import { arrowForwardOutline } from 'ionicons/icons';
import { isEmpty } from 'lodash';
import { ReactElement, useContext, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ChatMessage } from '../../api/graphql/generated';
import './chat.css';
import { ConversationMessage } from './conversation-message';
import { ConversationReplyList } from './conversation-reply-list';
import { NewReply } from './new-reply';

export interface ConversationPreviewProps {
  conversation: ChatMessage;
}

const NUM_PREVIEW_REPLIES = 3;

const ConversationPreview = (props: ConversationPreviewProps): ReactElement => {
  const { conversation } = props;
  const { i18n } = useTranslation();

  const isInputFocusedRef = useRef<boolean>(false);
  const { push } = useContext(IonRouterContext);

  const replies = useMemo(
    () => conversation.replies ?? [],
    [conversation?.replies]
  );

  const totalReplies = conversation.totalReplies ?? 0;

  const previewReplies: ChatMessage[] = useMemo(
    () => [...replies].slice(-NUM_PREVIEW_REPLIES),
    [replies]
  );

  return (
    <div
      className="chat-thread-container"
      onTouchStart={() => {
        if (!isEmpty(document.activeElement)) {
          isInputFocusedRef.current = true;
        } else {
          isInputFocusedRef.current = false;
        }
      }}
      onClick={() => {
        if (isInputFocusedRef.current === false) {
          push(`chat/${conversation.id}`);
        }
        isInputFocusedRef.current = false;
      }}
    >
      <ConversationMessage conversation={conversation} />
      <div className="chat-chip-container">
        <div className="chat-connector" />
        <div className="chat-chip-centered">
          <IonRouterLink
            routerLink={`chat/${conversation.id}`}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <IonChip>
              <IonLabel>
                {i18n.t('common:chat_open_conversation')}
                {totalReplies > 0 ? ` (${totalReplies})` : null}
              </IonLabel>
              <IonIcon icon={arrowForwardOutline} color="medium" />
            </IonChip>
          </IonRouterLink>
        </div>
      </div>
      <ConversationReplyList replies={previewReplies} />
      <div className="chip-preview-reply-container">
        <NewReply conversation={conversation} />
      </div>
    </div>
  );
};

export { ConversationPreview };
